export const RESTORE_PASSWORD_REQUEST = 'RESTORE_PASSWORD_REQUEST';
export const RESTORE_PASSWORD_SUCCESS = 'RESTORE_PASSWORD_SUCCESS';
export const RESTORE_PASSWORD_ERROR = 'RESTORE_PASSWORD_ERROR';
export const SEND_NEW_PASSWORD_REQUEST = 'SEND_NEW_PASSWORD_ERROR';
export const SEND_NEW_PASSWORD_SUCCESS = 'SEND_NEW_PASSWORD_REQUEST';
export const SEND_NEW_PASSWORD_ERROR = 'SEND_NEW_PASSWORD_SUCCESS';
